import Link from 'shared/timber/v1/Link'

import { useRouter } from 'next/router'
import Footer from '~/views/components/Footer'
import ProjectOverview from '~/views/components/ProjectOverview'
import { GetProjectOverview } from '~/use-cases/project/overview'

import RequestAccessDrawer from './RequestAccessDrawer'

import styles from './styles.module.scss'

interface Props {
  project: NonNullable<Required<GetProjectOverview.PublicResults['project']>>
  stats: NonNullable<Required<GetProjectOverview.PublicResults['stats']>>
}

const PublicProjectOverview = ({ project, stats }: Props) => {
  const router = useRouter()

  return (
    <div className={styles.PublicProjectOverview}>
      <div className={styles['PublicProjectOverview__Banner']}>
        <Link
          href={{ query: { projectId: project?.id, 'request-access': true } }}
        >
          Request Access to this Project
        </Link>
      </div>

      <main className={styles['PublicProjectOverview__Content']}>
        <ProjectOverview project={project} stats={stats} />
      </main>

      <Footer />

      <RequestAccessDrawer
        onClose={() => router.push({ query: { projectId: project?.id } })}
      />
    </div>
  )
}

export default PublicProjectOverview
